import { fromJS } from 'immutable';

export const initialState = {
  result: null,
  error: null,
  isLoading: false,
};

export const initReqStateImt = fromJS(initialState);
